var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { defineCustomTags } from "sb-resp-lib";
defineCustomTags("sb-resp-popup-content");
var Content = /** @class */ (function (_super) {
    __extends(Content, _super);
    function Content() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.html = React.createRef();
        _this.onTouchStart = _this.props.onTouchStart.bind(_this);
        _this.onTouchMove = _this.props.onTouchMove.bind(_this);
        return _this;
    }
    Content.prototype.componentDidMount = function () {
        if (this.html.current) {
            this.html.current.addEventListener("touchmove", this.onTouchMove, false);
        }
    };
    Content.prototype.componentWillUnmount = function () {
        if (this.html.current) {
            this.html.current.removeEventListener("touchmove", this.onTouchMove, false);
        }
    };
    Content.prototype.render = function () {
        return (React.createElement("sb-resp-popup-content", { ref: this.html, class: this.props.className, onTouchStart: this.onTouchStart, style: { top: this.props.top } }, this.props.children));
    };
    return Content;
}(React.Component));
export { Content };
//# sourceMappingURL=Content.js.map